import { API_URL } from '../../../app-config/constants';
import { DownloadableFile } from '../../../types/DownloadableFile';
import Token from '../../react/features/MeetingsDashboard/ReportWidget/Filter/Token';
import InsightsDto, { AggregationType, MeetingType } from '../../react/features/MeetingsDashboard/types/InsightsDto';
import { post } from '../request';

const BASE_PATH = `${API_URL}/meeting-insights`;

interface InsightsQuery {
    from: string;
    until?: string;
    aggregation: AggregationType;
    templateId: string | null;
    filters?: Token[];
    meetingType: MeetingType;
}

// Beware: don’t just turn on caching here unless you have properly
// tested it, you can run into odd edge-cases otherwise when applying
// different queries subsequently.
export function getInsights(query: InsightsQuery) {
    return post<InsightsDto[]>(BASE_PATH, {
        postData: toUrlQuery(query),
    });
}

export function getTeamInsights(query: InsightsQuery) {
    return post<InsightsDto[]>(`${BASE_PATH}/team`, {
        postData: toUrlQuery(query),
    });
}

export function triggerCsvDownload(query: InsightsQuery) {
    return post<DownloadableFile>(`${BASE_PATH}/download-csv`, {
        postData: toUrlQuery(query),
    });
}

function toUrlQuery(query: InsightsQuery) {
    const filters = (query.filters || []).reduce((prev, { key, term }) => ({ ...prev, [key]: term ?? '' }), {});
    return { ...{ ...query, filters } };
}
